import type { GetListingBannersItemResponse, GetListingBannersResponse } from '@/shared/api/experience';
import type { MaybeRefOrGetter, Ref } from 'vue';
import { useScreenSize } from '@experience/shared';

export function useBannerInjection(
  bannersData: Ref<GetListingBannersResponse | undefined>,
  page: MaybeRefOrGetter<number>,
  isPressedPagination: MaybeRefOrGetter<boolean>,
) {
  const BANNER_LIMIT = 50;

  const positionsOfBanners = computed(() => {
    const indexes: number[] = [];
    let current = 2;
    let bannerOffset = 3;

    while (current <= BANNER_LIMIT) {
      indexes.push(current);
      current += bannerOffset;
      bannerOffset = bannerOffset === 7 ? 3 : 7;
    }

    return indexes.slice(0, bannersData.value?.length || 1);
  });

  const isListingBannerIndex = (index: number) => positionsOfBanners.value.includes(index);

  const isShowBannerInjection = (index: number) => {
    return (
      bannersData.value?.length && (unref(page) === 1 || !unref(isPressedPagination)) && isListingBannerIndex(index)
    );
  };

  const currentBanner = (index: number): GetListingBannersItemResponse => {
    const indexOf = positionsOfBanners.value.indexOf(index);
    if (indexOf === -1) {
      return {} as GetListingBannersItemResponse;
    }

    return bannersData.value?.[indexOf] as GetListingBannersItemResponse;
  };

  /**
   * cколько надо пропустить карточек Э между врезками с подборками
   */
  const { isMobile, isTablet } = useScreenSize();
  const skipExpsSelectionInject = computed(() => {
    if (isMobile.value) {
      return 5;
    }

    if (isTablet.value) {
      return 6;
    }

    return 9;
  });

  const __indexIncrement = (index: number) => {
    let indexIncrement = 0;
    positionsOfBanners.value.forEach((i: number) => {
      if (i < index) {
        indexIncrement += 1;
      }
    });

    return indexIncrement;
  };

  const isShowSelectionsBlock = (index: number) => {
    if (index === 0) {
      return false;
    }

    const fullIndex = index + __indexIncrement(index) + 1;

    return fullIndex % skipExpsSelectionInject.value === 0;
  };

  const selectionIndex = (index: number) => {
    const fullIndex = index + __indexIncrement(index) + 1;

    return Math.floor(fullIndex / skipExpsSelectionInject.value) - 1;
  };

  return {
    isShowBannerInjection,
    currentBanner,
    isShowSelectionsBlock,
    selectionIndex,
  };
}
